import React from 'react';
import { FaTint } from 'react-icons/fa';

export const Footer = ({ changeView }) => (
  <footer className="bg-blue-900 pt-16 pb-8 px-4 relative z-10 border-t border-white/10">
    <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
      <div className="col-span-1 md:col-span-2">
        <div className="flex items-center gap-3 mb-6">
          <div className="bg-cyan-400 p-2.5 rounded-2xl shadow-lg shadow-cyan-400/20">
            <FaTint className="text-blue-900 text-xl" />
          </div>
          <span className="text-2xl font-black text-white tracking-tight">
            AquaGestión
          </span>
        </div>
        <p className="text-blue-200/60 text-sm leading-relaxed max-w-sm font-medium">
          Transformando la gestión del agua potable en Ecuador. Un
          sistema SaaS diseñado específicamente para las Juntas
          Administradoras de Agua Potable.
        </p>
      </div>
      <div>
        <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">
          Plataforma
        </h4>
        <ul className="space-y-4 text-sm text-blue-200/50">
          <li
            className="hover:text-cyan-400 cursor-pointer transition-colors"
            onClick={() => changeView("inicio")}
          >
            Inicio
          </li>
          <li
            className="hover:text-cyan-400 cursor-pointer transition-colors"
            onClick={() => changeView("nosotros")}
          >
            Beneficios
          </li>
          <li
            className="hover:text-cyan-400 cursor-pointer transition-colors"
            onClick={() => changeView("como-funciona")}
          >
            Funciones
          </li>
        </ul>
      </div>
      <div>
        <h4 className="font-bold text-white mb-6 uppercase tracking-wider text-sm">
          Servicios
        </h4>
        <ul className="space-y-4 text-sm text-blue-200/50">
          <li
            className="hover:text-cyan-400 cursor-pointer transition-colors"
            onClick={() => changeView("consultas")}
          >
            Portal de Pagos
          </li>
          <li
            className="hover:text-cyan-400 cursor-pointer transition-colors"
            onClick={() => changeView("login")}
          >
            Oficina Virtual
          </li>
          <li className="hover:text-cyan-400 cursor-pointer transition-colors">
            Soporte Técnico
          </li>
        </ul>
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-4 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-medium text-blue-200/30">
      <p>© 2026 AquaGestión by Polidevs. Todos los derechos reservados.</p>
      <div className="flex gap-8">
        <a href="/privacidad" className="hover:text-cyan-400 cursor-pointer transition-colors text-base font-semibold text-white">
          Privacidad
        </a>
        <span className="hover:text-white cursor-pointer transition-colors">
          Términos
        </span>
      </div>
    </div>
  </footer>
);
